<template>
    <div @mouseover="enter" @mouseleave="leave" id="head">
        <a :href="link" target="_blank" @click="leave">
            <svg viewBox="0 0 45.5 45.5">
                <title>LinkedIn</title>
                <circle id="LinkedInRing" cx="22.75" cy="22.75" r="22"/>
                <path id="LinkedInLogo" d="M15.5,21.4h3.9V35H15.5Zm1.9-1.7h0A2.31,2.31,0,0,1,15,17.3a2.31,2.31,0,0,1,2.4-2.4,2.4,2.4,0,1,1,0,4.8ZM35,35H30.6V28c0-1.8-.7-3.1-2.2-3.1a2.16,2.16,0,0,0-2.1,1.7,3.75,3.75,0,0,0-.1,1.1V35H21.8s.1-12.5,0-13.6h4.4v2.1a4.13,4.13,0,0,1,3.9-2.3c2.8,0,4.9,2,4.9,6.2V35Z" transform="translate(-2.25 -2.25)"/>
            </svg>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        link: String,
        darkMode: Boolean
    },
    methods: {
        enter: function () {
            // document.getElementById("LinkedInRing").style.stroke = "#FFFFFF";
            // document.getElementById("LinkedInRing").style.fill = "#0573B3";

            document.getElementById("LinkedInLogo").style.fill = "#FFFFFF";
        },
        leave: function () {
            // document.getElementById("LinkedInRing").style.stroke = this.darkMode ? "#000000" : "#FFFFFF";
            // document.getElementById("LinkedInRing").style.fill = "none";

            document.getElementById("LinkedInLogo").style.fill = this.darkMode ? "#000000" : "#FFFFFF";
        }
    },
    mounted() {
        // set light mode attributes, icon dark by default
        if (!this.darkMode) {
            // document.getElementById("LinkedInRing").style.stroke = "#FFFFFF";
            // document.getElementById("LinkedInRing").style.fill = "none";

            document.getElementById("LinkedInLogo").style.fill = "#FFFFFF";
        }
        // document.getElementById("LinkedInRing").style.stroke = "none";
    }    
}
</script>

<style scoped>
#head {
    height: 35px;
    width: 35px;
    margin-right: 5px;
    /* margin-bottom: 10px; */
}
a > svg > #LinkedInRing {
    fill: #0573B3;
    opacity: 0;
    stroke: none;
    stroke-width: 1.5px;
    transition: opacity .2s linear;
}
svg:hover > #LinkedInRing {
    opacity: 1;
}
#LinkedInLogo {
    fill-rule: evenodd;
}
svg {
    width: 35px;
    position: absolute;
}
</style>